// 移动端"返回顶部"悬浮按钮：滚动超过 1 屏后出现
import React, { useEffect, useState } from 'react';

export default function ScrollToTopButton({ threshold = 600 }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > threshold);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return (
    <button
      type="button"
      className={'scroll-top' + (visible ? ' visible' : '')}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="返回顶部"
      title="返回顶部"
    >
      ↑
    </button>
  );
}
